import allRoutes from "@forento/shared/routes"

const routes = allRoutes.platform

export default routes
